import React, { memo } from "react";
import { useRouter } from "next/router";

import {
  PageWrapper,
  ReviewsShowComponent,
  RecomendedQuests,
  TextComponent,
} from "components";

const ReviewContainer = (props: any) => {
  const router = useRouter();
  const { reviewListJSON, questListFirstData, isSingleReviewsView } = props;

  return (
    <div className={"flex flex-shrink-0 flex-col text-white"}>
      <PageWrapper>
        <TextComponent
        page="reviews"
          title={`Отзывы на ${ router?.pathname !== "/otzyvy" ? 'квест' : "квесты"} ${ router?.pathname !== "/otzyvy" ? reviewListJSON?.[0]?.quest?.name : "Old Mouse"}`}
          descriptionTexts="Еще больше отзывов, фото и видео в нашем инстаграме: @oldmouse.by. "
        />

        <ReviewsShowComponent {...props} />
      </PageWrapper>
      <RecomendedQuests questListFirstData={questListFirstData} />
    </div>
  );
};

export default memo(ReviewContainer);
